import { render, staticRenderFns } from "./ActDetail.vue?vue&type=template&id=aa8cae78&"
import script from "./ActDetail.vue?vue&type=script&lang=js&"
export * from "./ActDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports